import React from "react";

export const TextElement = ({path, element}) => {

  const text = (element?.text).replace("\n", "").trim() || "[text]";

  return (
    <>
      <pre className="vhe-text-element">
        {text}
      </pre>
    </>
  )
}